import { Typography } from '@carrier-io/air-react';
import Box from '@carrier-io/air-react/Box';
import styles from '../styles/Dashboard.module.css';

export const PendingStatus = () => {
  return (
    <Box className={styles.statusBox} style={{ backgroundColor: '#DDE4FF' }}>
      <Typography variant="body2" color="#0038FF" fontWeight={600}>
        Pending
      </Typography>
    </Box>
  );
};

export const OngoingStatus = () => {
  return (
    <Box className={styles.statusBox} style={{ backgroundColor: '#E0F7FA' }}>
      <Typography variant="body2" color="#0097A7" fontWeight={600}>
        Ongoing
      </Typography>
    </Box>
  );
};

export const FailedStatus = () => {
  return (
    <Box className={styles.statusBox} style={{ backgroundColor: '#FDE6E4' }}>
      <Typography variant="body2" color="#C5170A" fontWeight={600}>
        Failed
      </Typography>
    </Box>
  );
};

export const AbandonedStatus = () => {
  return (
    <Box className={styles.statusBox} style={{ backgroundColor: '#FFF0CC' }}>
      <Typography variant="body2" color="#9F7656" fontWeight={600}>
        Abandoned
      </Typography>
    </Box>
  );
};

export const CompletedStatus = () => {
  return (
    <Box className={styles.statusBox} style={{ backgroundColor: '#E4F3E4' }}>
      <Typography variant="body2" color="#357B38" fontWeight={600}>
        Completed
      </Typography>
    </Box>
  );
};

export const ExpiredStatus = () => {
  return (
    <Box className={styles.statusBox} style={{ backgroundColor: '#d6d8db' }}>
      <Typography variant="body2" color="#495057" fontWeight={600}>
        Expired
      </Typography>
    </Box>
  );
};
